import { render } from "./ArrowIcon.vue?vue&type=template&id=2c558a50&ts=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowIcon.vue?vue&type=script&lang=ts"

import "./ArrowIcon.vue?vue&type=style&index=0&id=2c558a50&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__